import OrderHistoryDetailMain from "../../component/Member/components/OrderHistoryDetail/OrderHistoryDetailMain";
import NavBar from "../../component/NavBar/NavBar";

function OrderHistoryDetail() {
    return (
        <>
            <NavBar />
            <OrderHistoryDetailMain />
        </>
    );
}

export default OrderHistoryDetail;